<template>
	<div class="payment-iframe-container">
		<div class="payment-header">
			<van-icon name="arrow-left" class="back-icon" @click="handleBack" />
			<div class="header-title">支付页面</div>
		</div>

		<div class="payment-info" v-if="showInfo">
			<van-icon name="info" />
			<span>正在跳转到支付页面，请完成支付...</span>
		</div>

		<div class="iframe-wrapper" v-if="payUrl">
			<iframe ref="paymentIframe" :src="payUrl" frameborder="0" class="payment-iframe" @load="onIframeLoad"
				@error="onIframeError"></iframe>

			<div v-if="iframeLoading" class="iframe-loading">
				<van-loading type="spinner" color="#1989fa" />
				<div class="loading-text">正在加载支付页面...</div>
			</div>
		</div>

		<div v-if="loadError" class="error-container">
			<van-icon name="warning" size="60" color="#ff4444" />
			<div class="error-title">支付页面加载失败</div>
			<div class="error-desc">请尝试重新打开或联系客服</div>
			<div class="action-buttons">
				<van-button type="default" @click="retryLoad">重试</van-button>
				<van-button type="primary" @click="handleBack">返回</van-button>
			</div>
		</div>

		<div class="payment-footer">
			<div class="footer-tips">
				<van-icon name="shield" color="#07c160" />
				<span>支付过程受银行/第三方支付平台安全保护</span>
			</div>
			<div class="footer-actions">
				<van-button type="default" size="small" @click="handleBack">
					返回
				</van-button>
				<!-- <van-button type="primary" size="small" @click="openInNewWindow" v-if="payUrl">
					新窗口打开
				</van-button> -->
			</div>
		</div>

		<!-- 支付成功弹窗 -->
		<van-popup v-model="showSuccessPopup" class="success-popup" :style="{ width: '80%' }"
			:close-on-click-overlay="false" @click="jumpToHomePage">
			<div class="popup-content">
				<img :src="successImg" class="success-img" alt="支付成功" />
			</div>
		</van-popup>

		<van-overlay :show="overlayLoading" z-index="999">
			<div class="overlay-content">
				<van-loading type="spinner" color="#1989fa" />
				<div class="overlay-text">处理中...</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import success1Img from '@/assets/icon/onlinePayment/success1.png';
	import success2Img from '@/assets/icon/onlinePayment/success2.png';
	import success3Img from '@/assets/icon/onlinePayment/success3.png';
	export default {
		name: 'PaymentIframe',
		data() {
			return {
				success1Img: success1Img,
				success2Img: success2Img,
				success3Img: success3Img,
				payUrl: '',
				orderId: '',
				id: null,
				iframeLoading: true,
				loadError: false,
				overlayLoading: false,
				showInfo: true,
				checkInterval: null,
				showSuccessPopup: false,
				successImg: '',
				countdownTimer: null
			};
		},
		created() {
			const payUrl = this.$route.query.payUrl;
			const orderId = this.$route.query.orderId;
			const id = this.$route.query.id;

			if (payUrl) {
				this.payUrl = payUrl;
				if (orderId) {
					this.orderId = orderId;
					// 开始轮询支付状态
					this.startPaymentStatusCheck();
				}
				if (id) {
					this.id = parseInt(id);
				}
			} else {
				this.loadError = true;
				this.$toast('支付链接无效');
			}

			this.$parent.footer('paymentIframe', false);
		},
		beforeDestroy() {
			// 清理定时器
			this.clearStatusCheck();
			this.clearCountdownTimer();
		},
		methods: {
			// iframe加载完成
			onIframeLoad() {
				console.log('支付页面加载完成');
				this.iframeLoading = false;

				// 3秒后隐藏提示信息
				setTimeout(() => {
					this.showInfo = false;
				}, 3000);
			},

			// iframe加载失败
			onIframeError() {
				console.error('支付页面加载失败');
				this.iframeLoading = false;
				this.loadError = true;
			},

			// 开始轮询支付状态
			startPaymentStatusCheck() {
				// 每5秒检查一次支付状态
				this.checkInterval = setInterval(() => {
					this.checkPaymentStatus();
				}, 5000);
			},

			// 检查支付状态
			async checkPaymentStatus() {
				try {
					// 调用API检查支付状态
					Fetch('/index/queryOrder', {
						orderId: this.orderId
					}).then(res => {
						this.isPaying = false;

						if (res.code === 1) {
							const status = res.data?.status;
							const paySuccTime = res.data?.paySuccTime;
							if (paySuccTime) {
								this.handlePaymentStatus();
							}
						}
					})
				} catch (error) {
					console.error('检查支付状态失败:', error);
				}
			},

			// 处理支付状态
			handlePaymentStatus() {
				this.clearStatusCheck();

				// 根据 id 设置不同的图片
				if (this.id === 0) {
					this.successImg = success1Img;
				} else if (this.id === 1) {
					this.successImg = success2Img;
				} else if (this.id === 2 || this.id === 3 || this.id === 4 || this.id === 5) {
					this.successImg = success3Img;
				}

				// 显示弹窗
				this.showSuccessPopup = true;

				// 开始倒计时，3秒后自动跳转
				this.startCountdown();
			},
			startCountdown() {
				this.countdownTimer = setTimeout(() => {
					this.jumpToHomePage();
				}, 3000);
			},
			clearCountdownTimer() {
				if (this.countdownTimer) {
					clearTimeout(this.countdownTimer);
					this.countdownTimer = null;
				}
			},
			jumpToHomePage() {
				this.clearCountdownTimer();
				this.showSuccessPopup = false;
				this.$router.push('/');
			},

			// 清理状态检查
			clearStatusCheck() {
				if (this.checkInterval) {
					clearInterval(this.checkInterval);
					this.checkInterval = null;
				}
			},

			// 重新加载
			retryLoad() {
				this.loadError = false;
				this.iframeLoading = true;

				// 强制iframe重新加载
				if (this.$refs.paymentIframe) {
					this.$refs.paymentIframe.src = this.payUrl;
				}
			},

			// 在新窗口打开
			// openInNewWindow() {
			// 	if (this.payUrl) {
			// 		window.open(this.payUrl, '_blank');
			// 		window.location.href = this.payUrl;
			// 		this.$toast('已在浏览器新窗口打开支付页面');
			// 	}
			// },

			// 返回上一页
			handleBack() {
				this.$dialog.confirm({
					title: '确认返回',
					message: '支付尚未完成，确定要返回吗？',
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					this.$router.back();
				}).catch(() => {
					// 取消操作
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.payment-iframe-container {
		height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: #f5f5f5;
	}

	.payment-header {
		position: relative;
		height: 50px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
		z-index: 10;

		.back-icon {
			position: absolute;
			left: 15px;
			font-size: 20px;
			color: #333;
		}

		.header-title {
			font-size: 18px;
			font-weight: bold;
			color: #333;
		}
	}

	.payment-info {
		background: #e6f7ff;
		padding: 12px 16px;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #1890ff;
		border-bottom: 1px solid #91d5ff;

		.van-icon {
			margin-right: 8px;
			font-size: 16px;
		}
	}

	.iframe-wrapper {
		flex: 1;
		position: relative;
		overflow: hidden;

		.payment-iframe {
			width: 100%;
			height: 100%;
			border: none;
		}

		.iframe-loading {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background: rgba(255, 255, 255, 0.9);

			.loading-text {
				margin-top: 15px;
				font-size: 14px;
				color: #666;
			}
		}
	}

	.error-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 30px;
		text-align: center;

		.error-title {
			margin-top: 20px;
			font-size: 18px;
			font-weight: bold;
			color: #333;
		}

		.error-desc {
			margin-top: 10px;
			font-size: 14px;
			color: #666;
			margin-bottom: 30px;
		}

		.action-buttons {
			display: flex;
			gap: 15px;

			.van-button {
				min-width: 100px;
			}
		}
	}

	.payment-footer {
		background: #fff;
		padding: 15px;
		border-top: 1px solid #f0f0f0;

		.footer-tips {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			color: #666;
			margin-bottom: 15px;

			.van-icon {
				margin-right: 5px;
			}
		}

		.footer-actions {
			display: flex;
			justify-content: space-between;
			gap: 15px;

			.van-button {
				flex: 1;
			}
		}
	}

	.success-popup {
		background: transparent;
		border-radius: 16px;
		overflow: hidden;

		.popup-content {
			background: transparent;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
		}

		.success-img {
			width: 100%;
			height: auto;
			border-radius: 16px;
			display: block;
		}
	}

	.overlay-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;

		.overlay-text {
			margin-top: 15px;
			color: #fff;
			font-size: 16px;
		}
	}

	@media (max-width: 768px) {
		.payment-header {
			height: 44px;

			.header-title {
				font-size: 16px;
			}
		}

		.payment-info {
			font-size: 13px;
			padding: 10px 15px;
		}

		.success-popup {
			width: 85% !important;
		}
	}
</style>